<template>
    <div class="p-3">
        <h3>DATA DASAR RUMAH SAKIT</h3>
        <hr>

        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header text-white bg-primary">DATA DASAR RUMAH SAKIT</div>
                    <div class="card-body">
                        <template>
                            <div class="row">
                                <div v-for="(data, idx) in update_data">
                                    <div class="row mb-12" :key="idx" v-if="input_labels[idx]"
                                        style="margin-top: 10px;">
                                        <label :for="idx" class="col-sm-4 col-form-label text-end">{{ input_labels[idx]
                                            }}</label>
                                        <div class="col-sm-6">
                                            <input :name="idx" v-if="inArray(idx, input_number)" type="number" :id="idx"
                                                class="form-control" v-model="update_data[idx]" @change="validate(idx)">

                                            <input :name="idx" v-if="inArray(idx, input_date)" type="date" :id="idx"
                                                class="form-control" v-model="update_data[idx]" @change="validate(idx)">

                                            <input :name="idx" v-if="!inArray(idx, input_filtered)" type="text"
                                                :id="idx" class="form-control" v-model="update_data[idx]"
                                                @change="validate(idx)">

                                        </div>
                                    </div>
                                </div>
                                <label style="margin-top: 10px;" class="col-sm-4 col-form-label text-end">Tenaga
                                    Medis</label>
                                <div v-for="(datadok, dokx) in detail_dokter">
                                    <div class="row mb-12" :key="dokx" v-if="label_dokter[dokx]"
                                        style="margin-top: 10px;">
                                        <label :for="dokx" class="col-sm-4 col-form-label text-end">{{
                                    label_dokter[dokx]
                                }}</label>
                                        <div class="col-sm-6">
                                            <input :name="dokx" v-if="!inArray(dokx, dokter_filtered)" type="text"
                                                :id="dokx" class="form-control" v-model="update_dokter[dokx]" disabled>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </template>


                        <div class="row">
                            <div class="col text-end">
                                <button class="btn btn-sm btn-success" @click="saveRS">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            detail_data: [],
            detail_dokter: [],
            update_data: [],
            update_dokter: [],
            input_labels: {
                'Tahun': 'Tahun',
                'NomorKodeRS': 'Nomor Kode RS',
                'TanggalRegistrasi': 'Tanggal Registrasi',
                'NamaRS': 'Nama Rumah Sakit',
                'JenisRS': 'Jenis Rumah Sakit',
                'KelasRS': 'Kelas Rumah Sakit',
                'NamaDirekturRS': 'Nama Direktur Rumah Sakit',
                'NamaPenyelenggaraRS': 'Nama Penyelenggara Rumah Sakit',
                'AlamatRS': 'Alamat / Lokasi Rumah Sakit',
                'KotaKab': 'Kab/Kota',
                'KodePos': 'Kode Pos',
                'Telepon': 'Telepon',
                'Fax': 'Fax',
                'Email': 'Email',
                'NoTelpHumas': 'No. Telp Bag Umum/Humas RS',
                'Website': 'Website',
                'LuasTanah': 'Luas Rumah Sakit (Tanah)',
                'LuasBangunan': 'Luas Rumah Sakit (Bangunan)',
                'SuratIzin': 'Surat Izin/Penetapan',
                'StatusPenyelenggaraSwasta': 'Status Penyelenggara Swasta',
                'Akreditasi': 'Akreditasi Rumah Sakit',

            },
            input_date: ['TanggalRegistrasi'],
            input_number: ['Tahun'],
            label_dokter: {
                'dokter_SpOT': 'Dokter Sp.OT',
                'dokter_SpBH': 'Dokter Sp.BH',
                'dokter_SpTHT': 'Dokter Sp.THT',
                'dokter_SpJP': 'Dokter Sp.JP',
                'dokter_drg': 'Dokter drg',
                'dokter_SpKGA': 'Dokter Sp.KGA',
                'dokter_SpA': 'Dokter Sp.A',
                'dokter_SpOG': 'Dokter Sp.OG',
                'dokter_SpB': 'Dokter Sp.B',
                'dokter_SpRad': 'Dokter Sp.Rad',
                'dokter_SpRM': 'Dokter Sp.RM',
                'dokter_SpAn': 'Dokter Sp.An',
                'dokter_SpM': 'Dokter Sp.M',
                'dokter_SpKj': 'Dokter Sp.Kj',
                'dokter_umum': 'Dokter Umum',
                'dokter_SpKFR': 'Dokter Sp. KFR',
                'dokter_MPsi': 'Dokter M.Psi, Psikolog',
                'dokter_SpPK': 'Dokter Sp.PK',
                'dokter_SpS': 'Dokter Sp.S',
                'dokter_SpU': 'Dokter Sp.U',
                'dokter_SpKK': 'Dokter Sp.KK',
                'dokter_SpBM': 'Dokter Sp.BM',
                'dokter_SpBOnk': 'Dokter Sp.B.Onk',
                'dokter_SpP': 'Dokter Sp.P',
                'dokter_SpPD': 'Dokter Sp.PD',
                'perawat': 'Perawat',
                'bidan': 'Bidan',
                'farmasi': 'Farmasi Apoteker',



            },
            input_filtered: [],
            dokter_filtered: [],

        }
    },
    created() {
        this.input_filtered = [...this.input_date, ...this.input_number]

    },
    mounted() {
        this.getDataRS()
        this.getTenaagaMendis()
    },
    updated() {

    },
    methods: {
        validate(field) {
            console.log('field:', field)
            console.log('update_data:', this.update_data)
        },
        getDataRS() {
            const uri = `/api/external-rs/get-external-rs`

            this.axios.get(uri).then(response => {
                const status = response.data.status
                if (status == 'success') {
                    this.detail_data = response.data.data
                    this.update_data = { ...this.detail_data }
                }
            })
        },
        getTenaagaMendis() {
            const uri = `/api/external-rs/get-tenaga-medis`

            this.axios.get(uri).then(response => {
                const status = response.data.status
                if (status == 'success') {
                    this.detail_dokter = response.data.data
                    this.update_dokter = { ...this.detail_dokter }

                }
            })
        },
        saveRS() {
            const uri = `/api/external-rs/update-data`

            this.axios.post(uri, { update_data: this.update_data }).then(response => {
                if (response.data.status == 'success') {
                    this.$swal.fire({
                        title: 'Berhasil!',
                        text: "Data Berhasil diupdate",
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            })
        },
    }
}
</script>